import React from 'react'
import "./WhatIs.less"
import CalculatorStore from "../../Configs/Store/calculator"
import "../../styles/Benefits/Benefit.less"
import { observer } from "mobx-react"

const WhatIs = observer(() => {
  // const device = AppStore.device

  return (
    <div className="WhatIsRoot"
    //  style={{ marginTop: CalculatorStore.screenNo === "Scr6" || AppStore.device === 0 ? "10px" : "10px" }}
    > <div className='WhatIsContainer'>
        <div className="WhatIsHeader">
          <img className="WhatIsImg" alt='WhatIs' src='assets/WhatIs/WhatIs.svg' />
          <h2 className="WhatIsHeading">What is a Pension Plan Calculator?</h2></div>
        <p className="WhatIsContent">
          <span>Retirement only means that your regular salary stops. This doesn’t mean that your expenses stop. This is why the earlier you plan for your
            retirement the better it is.</span>
          <span>As time progress, goods and services become expensive with growing inflation. This in turn reduces the buying power of the money you have. Using a pension calculator can show you how much money you would require after retirement.
          </span><span >A pension calculator can also help you to understand, how much money you need to invest towards your achieving your retirement plan. Depending on the frequency of your contribution and the amount that you invest over time,
            the pension calculator will help you calculate the lump sum amount that you can get when you retire.</span ></p></div ></div >
  )

})

export default WhatIs